import { useState } from "react";

import { Collapse, RotatingChevron, Button } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";
import PropTypes from "prop-types";

import LeftAlignIcon from "@/icons/LeftAlignIcon";
import VideoTranscript from "../../VideoTranscript";
import {
  collapseContainerCss,
  collapseCustomTriggerCss,
  transcriptLabelWrapper,
  transcriptIconCss,
  transcriptLabelCss,
} from "./CollapsibleTranscript.style";

const ButtonWithTrackEvent = withTrackEvent(Button);

const propTypes = {
  contentId: PropTypes.string,
};

const CollapsibleTranscript = ({ contentId }) => {
  const [isTranscriptHidden, setIsTranscriptHidden] = useState(false);
  const dataQaSelector = isTranscriptHidden
    ? "transcript-hidden"
    : "transcript-visible";
  const eventDescription = isTranscriptHidden
    ? "Show transcript"
    : "Hide transcript";
  const ariaLabel = isTranscriptHidden
    ? "Expand Transcript"
    : "Collapse Transcript";
  const eventProperties = {
    objectType: objectTypes.content,
    actionPrefix: actionPrefixes.initiate,
    actionName: actionNames.read,
    streamProperties: {
      event_name: "Transcript Interact",
      content_type: "interactivevideolink",
      content_id: contentId,
      description: eventDescription,
    },
  };

  // Proptype for renderCustomTrigger must be a function.
  const renderCollapseHeader = () => {
    return (
      <div css={collapseCustomTriggerCss}>
        <span css={transcriptLabelWrapper}>
          <LeftAlignIcon css={transcriptIconCss} />
          <h4 css={transcriptLabelCss}>Transcript</h4>
        </span>
        <ButtonWithTrackEvent
          {...eventProperties}
          ariaProps={{ "aria-label": ariaLabel }}
          dataProps={{ "data-qa-selector": dataQaSelector }}
          flavor={Button.flavors.incognito}
          onClick={() => {
            setIsTranscriptHidden(!isTranscriptHidden);
          }}
        >
          <RotatingChevron isDown={isTranscriptHidden} />
        </ButtonWithTrackEvent>
      </div>
    );
  };

  return (
    <Collapse
      __cssFor={{
        root: collapseContainerCss,
      }}
      isHidden={isTranscriptHidden}
      renderCustomTrigger={renderCollapseHeader}
    >
      <VideoTranscript contentId={contentId} />
    </Collapse>
  );
};

CollapsibleTranscript.propTypes = propTypes;

export default CollapsibleTranscript;
